class LastDayAlertController {

  constructor() {

  }

  $onInit() {
  }
}

export default LastDayAlertController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/lastDayAlert/lastDayAlert.controller.js